import Analytics, { AnalyticsInstance } from 'analytics';
import { env } from '@/env';
import { AnalyticsJucyBookingFunnelPlugin, analyticsJucyBookingFunnel } from './plugins/analyticsJucyBookingFunnel';
import { AnalyticsEcommercePlugin, analyticsJucyEcommerce } from './plugins/analyticsJucyEcommerce';
import { analyticsJucyGtm } from './plugins/analyticsJucyGtm';
import { AnalyticsJucyInteractionsPlugin, analyticsJucyInteractions } from './plugins/analyticsJucyInteraction';

if (env.NEXT_PUBLIC_ENV !== 'prod' && typeof window !== 'undefined' && env.NEXT_PUBLIC_MOCK_DATALAYER === 'true') {
    const jucyDataLayer: NonNullable<unknown>[] = [];
    const jucyDataLayerOrigPush = jucyDataLayer.push;
    jucyDataLayer.push = (...payload) => {
        // eslint-disable-next-line no-console
        console.groupCollapsed(`%cwindow.dataLayer.push ${'event' in payload[0] ? payload[0].event : 'Unknown event'}`, 'color: orange;');
        // eslint-disable-next-line no-console
        console.log(...payload);
        // eslint-disable-next-line no-console
        console.groupEnd();

        return jucyDataLayerOrigPush.call(jucyDataLayer, ...payload);
    };
    window.dataLayer = jucyDataLayer;
}

const sharedConfig = { debug: env.NEXT_PUBLIC_DEBUG_ANALYTICS };
type JucyAnalytics = AnalyticsInstance & {
    plugins: AnalyticsInstance['plugins'] & {
        interactions: AnalyticsJucyInteractionsPlugin['methods'];
        ecommerce: AnalyticsEcommercePlugin['methods'];
        bookingFunnel: AnalyticsJucyBookingFunnelPlugin['methods'];
    };
};
const analytics = Analytics({
    ...sharedConfig,
    app: 'oconee',
    plugins: [
        analyticsJucyGtm({ ...sharedConfig }),
        analyticsJucyInteractions({ ...sharedConfig }),
        analyticsJucyEcommerce({ ...sharedConfig }),
        analyticsJucyBookingFunnel({ ...sharedConfig }),
    ],
}) as JucyAnalytics;

export default analytics;
